import { render, staticRenderFns } from "./gruppiStato.vue?vue&type=template&id=6d409119&"
import script from "./gruppiStato.vue.ts?vue&type=script&lang=ts&"
export * from "./gruppiStato.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports